export enum TagsTypeOptions {
  source = 'source',
  network = 'network',
}
